lmApp.controller('OwnerAuthController', ['$scope', '$rootScope', '$kookies', '$timeout', '$location',
  function ($scope, $rootScope, $kookies, $timeout, $location) {
    $scope.loginFormData = {
      error: '',
      inputs: {
        token: ''
      }
    };

    $scope.login = function () {
      $rootScope.globals.currentUser = {
        isSuperuser: true,
        readOnly: true,
        project: '',
        company_name: '',
        supervisorToken: $scope.loginFormData.inputs.token,
        username: '',
        token: $scope.loginFormData.inputs.token,
        operatorToken: null,
        name: '',
        account: {
          groups: ['admin']
        }
      };

      $rootScope._self = $rootScope.globals.currentUser;
      $rootScope.$broadcast('self:update', $rootScope._self);

      lh.common.config.set({authToken: $scope.loginFormData.inputs.token});
      lh.system.init();

      $kookies.set('globals', JSON.stringify($rootScope.globals), {path: '/', expires: 7});
      $timeout(function () {
        $location.path($rootScope.defaultAdminRoute);
      }, 1000);
    }
  }]);